/** Where a new room is made. One definition, used by the routes and the list. */
export const BOARD_NEW_PATH = "/rooms/new";

/** One room's board (Walk it through), resumed. */
export function boardPath(webinarId: string): string {
  return `/rooms/${webinarId}/walk`;
}

